(() => {
  const KEY = 'lfc_recently_viewed';

  const latestProduct = () => {
    try {
      const items = JSON.parse(localStorage.getItem(KEY)) || [];
      return items.find((item) => item.productId && item.available !== false);
    } catch (_) {
      return null;
    }
  };

  const removeDuplicates = (container, host, currentHandle = '') => {
    const existingHandles = new Set(
      Array.from(document.querySelectorAll('[data-home-product-card]'))
        .filter((card) => !host.contains(card))
        .map((card) => card.dataset.productHandle)
    );
    container.querySelectorAll('[data-home-product-card]').forEach((card) => {
      if (existingHandles.has(card.dataset.productHandle) || card.dataset.productHandle === currentHandle) {
        card.closest('.home-recs__product')?.remove();
      }
    });
  };

  const fillWithFallback = (incoming, fallbackItems, limit) => {
    const list = incoming.querySelector('.home-recs__products');
    if (!list) return;
    const handles = new Set(
      Array.from(list.querySelectorAll('[data-home-product-card]')).map((card) => card.dataset.productHandle)
    );
    for (const item of fallbackItems) {
      if (list.querySelectorAll('.home-recs__product').length >= limit) break;
      const card = item.querySelector('[data-home-product-card]');
      const handle = card?.dataset.productHandle;
      if (!handle || handles.has(handle)) continue;
      list.append(item.cloneNode(true));
      handles.add(handle);
    }
  };

  const load = async (host) => {
    if (host.dataset.loaded === 'true') return;
    host.dataset.loaded = 'true';
    const item = latestProduct();
    const limit = Math.max(1, Number(host.dataset.limit) || 6);
    const currentContent = host.querySelector('[data-recommendations-content]');
    removeDuplicates(currentContent, host, item?.handle || '');
    const fallbackItems = Array.from(currentContent.querySelectorAll('.home-recs__product')).map((node) => node.cloneNode(true));
    if (!currentContent.querySelector('[data-home-product-card]')) host.hidden = true;
    if (!item) {
      host.dispatchEvent(new CustomEvent('lfc:home_cards_updated', { bubbles: true }));
      return;
    }

    const url = new URL(`${window.Shopify?.routes?.root || '/'}recommendations/products`, window.location.origin);
    url.searchParams.set('section_id', host.dataset.sectionId);
    url.searchParams.set('product_id', item.productId);
    url.searchParams.set('limit', '10');
    url.searchParams.set('intent', 'related');

    try {
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) return;
      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const incoming = documentFragment.querySelector('[data-recommendations-content]');
      if (!incoming || !incoming.querySelector('[data-home-product-card]')) return;
      removeDuplicates(incoming, host, item.handle);
      fillWithFallback(incoming, fallbackItems, limit);
      if (!incoming.querySelector('[data-home-product-card]')) return;
      const content = host.querySelector('[data-recommendations-content]');
      content.replaceWith(incoming);
      host.hidden = false;
      host.dispatchEvent(new CustomEvent('lfc:home_cards_updated', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('lfc:home_recommendations_loaded', {
        detail: { productId: item.productId }
      }));
    } catch (_) {}
  };

  const init = (scope = document) => scope.querySelectorAll('[data-home-recommendations]').forEach(load);
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
